module.exports = __webpack_public_path__ + "img/eiernockel.f8862189.png";